// Dialog aplikasi pengganti window.confirm / window.prompt / window.alert (inventaris C19, MANDAT-TUNTAS-25SEP butir 8).
// Dialog browser mentah tidak mengikuti tema, tidak bisa diberi aturan isian, dan di beberapa browser bisa dimatikan
// pengguna ("jangan tampilkan dialog lagi") sehingga tombol diam-diam tidak melakukan apa pun.
//
//   if (!(await konfirmasi("Hapus?"))) return;          // true / false
//   const alasan = await mintaTeks("Alasan (wajib):", { minPanjang: 5 });   // string / null bila batal
//
// Satu <DialogAplikasi/> dipasang di App.js; modul ini hanya antrean permintaan. Pagar statis
// `frontend/src/lib/pagarDialogMentah.test.js` merah bila window.confirm/prompt/alert muncul lagi.

let pendengar = null;
const antrean = [];

function kirim(permintaan) {
  return new Promise((selesai) => {
    antrean.push({ ...permintaan, selesai });
    if (pendengar) pendengar([...antrean]);
  });
}

/** Dipakai komponen DialogAplikasi: berlangganan antrean. */
export function langganan(fn) {
  pendengar = fn;
  fn([...antrean]);
  return () => { if (pendengar === fn) pendengar = null; };
}

/** Menutup permintaan terdepan dengan hasilnya. */
export function jawab(hasil) {
  const p = antrean.shift();
  if (p) p.selesai(hasil);
  if (pendengar) pendengar([...antrean]);
}

export function konfirmasi(pesan, { judul = "Konfirmasi", ya = "Lanjutkan", bahaya = false } = {}) {
  return kirim({ jenis: "konfirmasi", pesan, judul, ya, bahaya });
}

export function mintaTeks(pesan, { judul = "Isian diperlukan", awal = "", minPanjang = 0, ya = "Simpan", multiBaris = true } = {}) {
  return kirim({ jenis: "teks", pesan, judul, awal: awal ?? "", minPanjang, ya, multiBaris });
}

export function beriTahu(pesan, { judul = "Informasi" } = {}) {
  return kirim({ jenis: "info", pesan, judul, ya: "Tutup" });
}
